const types = {
	//Get Template name
	GET_SAMPLE_NAME_START: "GET_SAMPLE_NAME_START",
	GET_SAMPLE_NAME_SUCCESS: "GET_SAMPLE_NAME_SUCCESS",
	GET_SAMPLE_NAME_ERROR: "GET_SAMPLE_NAME_ERROR",
	GET_SAMPLE_NAME_RESET: "GET_SAMPLE_NAME_RESET",

	//Create Template name
	CREATE_SAMPLE_NAME_START: "CREATE_SAMPLE_NAME_START",
	CREATE_SAMPLE_NAME_SUCCESS: "CREATE_SAMPLE_NAME_SUCCESS",
	CREATE_SAMPLE_NAME_ERROR: "CREATE_SAMPLE_NAME_ERROR",
	CREATE_SAMPLE_NAME_RESET: "CREATE_SAMPLE_NAME_RESET",

	//delete Template name
	DELETE_SAMPLE_NAME_START: "DELETE_SAMPLE_NAME_START",
	DELETE_SAMPLE_NAME_SUCCESS: "DELETE_SAMPLE_NAME_SUCCESS",
	DELETE_SAMPLE_NAME_ERROR: "DELETE_SAMPLE_NAME_ERROR",
	DELETE_SAMPLE_NAME_RESET: "DELETE_SAMPLE_NAME_RESET",

	//update Template name
	UPDATE_SAMPLE_NAME_START: "UPDATE_SAMPLE_NAME_START",
	UPDATE_SAMPLE_NAME_SUCCESS: "UPDATE_SAMPLE_NAME_SUCCESS",
	UPDATE_SAMPLE_NAME_ERROR: "UPDATE_SAMPLE_NAME_ERROR",
	UPDATE_SAMPLE_NAME_RESET: "UPDATE_SAMPLE_NAME_RESET",

	//single item  name
	SINGLE_SAMPLE_NAME_START: "SINGLE_SAMPLE_NAME_START",
	SINGLE_SAMPLE_NAME_SUCCESS: "SINGLE_SAMPLE_NAME_SUCCESS",
	SINGLE_SAMPLE_NAME_ERROR: "SINGLE_SAMPLE_NAME_ERROR",
	SINGLE_SAMPLE_NAME_RESET: "SINGLE_SAMPLE_NAME_RESET",
};

export default types;
